import React, { Component } from "react";
import moment from "moment";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import Table from "../../components/Table";
import routes from "../../routes/URL";
import Toast from "../../components/Toast";
import Header from "../../components/Header";

class ListHotelScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      version: 1,
      toast: {
        open: false,
        message: "",
        severity: "success"
      }
    };
  }

  componentDidMount() {}

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  }

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  }

 onSwitch = async (item, value) => {
  console.log("Switch: ", item.id);
  const { status, message, data } = await API(
    this,
    "post",
    URL_PATH.updateTableStatus(item.id), // Make sure this matches your API endpoint path
    {
      table_status_on_off: value ? "1" : "0", // Convert boolean to "1" or "0" string
    }
  );
  
  if (status === "success") {
    this.showToast( message, "success");
    // Refresh the table data
    this.setState({ version: this.state.version + 1 });
  } else {
    this.showToast(message || "Failed to update table status", "error");
  }
}

  onDelete = async (item) => {
    console.log("sure to delete?");
    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.deleteTable(item.id)
    );
    if (status == "success") {
      this.showToast("The table has been deleted successfully.", "success");
      this.setState({ version: this.state.version + 1 });
    } else {
      this.showToast(message, "error");
    }
  };

  onEdit = async (item) => {
  
    this.props.history.push(routes.admin.floors.updateTable(this.props.hotels[0].hotel_slug,item.hotel_floor.slug,item.slug ,item.id))
    
  };

  onView = async (item) => {};

  render() {
    return (
      <div className="container-fluid">
        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />
        
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <Header title={this.props.match.params.floor}/>
          <div
            className="btn "
            style={{ backgroundColor: "#FFC857", color: "#000", fontWeight: "700" }}
            onClick={() => {
              this.props.history.push(
                routes.admin.floors.createTable(
    this.props.match.params.hotelSlug,  // or this.props.hotels[0].hotel_slug if that's correct
                  this.props.match.params.floor,
                  this.props.match.params.id
                )
              );
            }}
          >
            + ADD TABLE
          </div>
        </div>

        <Table
          key={this.state.version}
          api={URL_PATH.listTable(this.props.match.params.id)}
          onEdit={this.onEdit}
          deleteText="delete all data related to this table."
          searchPlaceholder="Search by table no"

          onDelete={this.onDelete}
          row={[
            {
              title: "No",
              key: "table_no",
              sortable: true,
            },
            {
              title: "Type",
              key: "type",
              parseFunction: (col, row) => {
                const rtype =
                  row.type == "table"
                    ? "Table"
                    : row.type == "room"
                    ? "Room"
                    : row.type == "bhall"
                    ? "Birthday Hall"
                    : "";
                return rtype;
              },
              sortable: true,
            },
            {
              title: "Capicity",
              key: "table_capacity",
              sortable: true,
            },
                         {
              title: "Available",
              key: "table_status_on_off",
               type: "switch",
              sortable: true,
              onSwitch: this.onSwitch,
            },
          ]}
        />
      </div>
    );
  }
}

export default redux(ListHotelScreen);